// 通用的一些名词
export default {
    'common.language.change':'切换语言',
    'common.company.name':'达强（深圳）国际物流有限公司',
    'common.company.copyright':'Copyright © 2022 达强（深圳）国际物流有限公司 版权所有',
    'common.company.beian.icp':'苏—ICP备',
    'common.company.beian.gwa':'苏公网安备',
    'common.company.address-title':'地址：',
    'common.company.address-info':'广东省深圳市龙华区大浪工业园',
    'common.navigation.title.home':'首页',
    'common.navigation.title.about':'关于我们',
    'common.navigation.title.query':'物流查询',
    'common.navigation.title.track':'运输线路',
    'common.navigation.title.contact':'联系我们',
    'common.footer.slogan':'达强（深圳）国际物流有限公司自成立以来便不断寻求突破，公司通过多年的积累已经形成一套特有的贸易和物流服务体系,致力于为全球用户提供专业、准确、高效的贸易和物流服务！',
    'common.footer.map.website-map':'网站地图',
    'common.footer.map.help-center':'帮助中心',
    'common.footer.map.help-center.question':'常见问题',
    'common.footer.map.help-center.service':'客户服务',
    'common.footer.map.help-center.message':'网站留言',
    'common.footer.map.help-center.price':'价格咨询',
    'common.footer.map.contact-us':'联系我们',
    'common.footer.map.contact-us.whatsApps':'WhatsApp: +86 18576744474',
    'common.footer.map.contact-us.skype':'skype: +86 18576744474',
    'common.footer.dialog.title':'提示',
    'common.footer.dialog.content':'如有问题请咨询 电话：+86 18688782252，whatsApp,skype +86 18576744474'
}